import React from "react";
import { DeviceCreateTemplate } from "themes/application/device-settings/pages";
import { DeviceCreateViewStore } from "application/device-settings/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) =>
        new DeviceCreateViewStore(rootStore, componentProps),
    "deviceCreateViewStore"
)
class DeviceCreate extends React.Component {
    render() {
        return <DeviceCreateTemplate {...this.props} />;
    }
}

export default DeviceCreate;
